<template>
    <div class="x-form-dialog">
        <x-form-view ref="form"
            :config="getFormConfig(formConfig)"
            :data="data"
            @update:data="(value)=>$emit('update:data', value)"
            :view-state="ViewState.CREATE"
        ></x-form-view>
    </div>
</template>
<script setup>
import { getCurrentInstance, ref, watch } from 'vue';
import XFormView from './XFormView.vue';
import ViewType from '../dataview/ViewType';
import PageFlowEngine from '../pageflow/PageFlowEngine';
import ViewState from './ViewState';

const inst = getCurrentInstance();

const props = defineProps({
    config: { default: null },
    data: { default: null },
})

defineEmits({
    'update:data': null,
})

const buildConfig = (config)=> {
    const fields = [];
    for (const field of config.fields) {
        fields.push(Object.assign({}, field, {width:field.width || 24}));
    }
    return {
        type:ViewType.FORM, withDefaultButtons:false, view: {
            module: config.module,
            fields: fields
        },
    }
}

const formConfig = ref(PageFlowEngine.transformFormConfig(buildConfig(props.config)));
watch(()=> props.config, (value)=> {
    const conf = PageFlowEngine.transformFormConfig(buildConfig(value));
    formConfig.value = conf;
})

const getFormConfig = (config)=> {
    if (!config) return null;
    config.withDefaultButtons = false;
    return config;
}

const validateForm = async ()=> {
    return await inst.refs.form['validateForm']();
}

defineExpose({
    validateForm,
})
</script>